export default __webpack_public_path__ + "static/media/bulb.2a1fa5d6.jpg";